module.exports = __webpack_public_path__ + "static/media/cctv-marker.039e23aa.svg";